<kal-button (click)="openCommentTableContainer()"
            *ngIf="hasComment"
            kalTheme="tertiary">
    <kal-icon>chat_bubble_outline</kal-icon>
</kal-button>
